import {
  UPDATE_LOCATION,
  UPDATE_APPL_PARAMETER,
  ADD_LOCAITON,
  ADD_APPL_PARAMETER,
  GET_ALL_LOCATIONS,
  GET_ALL_APPL_PARAMETERS_1
} from '@/api/endpoints/adminControllerEndpoints'
import axios from '@/api/api.js'

export const updateLocation = async location => {
  try {
    const response = await axios.post(UPDATE_LOCATION, location, {
      headers: {
        token:
          'eyJhbGciOiJIUzUxMiJ9.eyJMT0dJTl9JRCI6IkFTRUxFQVAiLCJVU0VSX1RZUEUiOiJDVVNUT01FUiIsIlVTRVJfSUQiOiIxMDU5IiwiQVVESVRfSUQiOjE0MDQsInN1YiI6IkFTRUxFQVAiLCJpYXQiOjE3NTc2MDczMTEsImV4cCI6MTc1NzYxNzMxMX0.HaEX-cCmHLr3eySyklfuMbOqCxNalFQRmzjLSspvg4yprJxpEbhzXQzK9x7dwQ5MuV4iKPJaFrC2gSeZHHB-xQ'
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching updateLocation data: ', error)
    throw error
  }
}

export const updateApplParameter = async applParameter => {
  try {
    const response = await axios.post(UPDATE_APPL_PARAMETER, applParameter)
    return response.data
  } catch (error) {
    console.error('Error fetching updateApplParameter data: ', error)
    throw error
  }
}

export const addLocation = async location => {
  try {
    const response = await axios.post(ADD_LOCAITON, location)
    return response.data
  } catch (error) {
    console.error('Error fetching addLocation data: ', error)
    throw error
  }
}

export const addApplParameter = async applParameter => {
  try {
    const response = await axios.post(ADD_APPL_PARAMETER, applParameter)
    return response.data
  } catch (error) {
    console.error('Error fetching addApplParameter data: ', error)
    throw error
  }
}

export const getAllLocations = async () => {
  try {
    const response = await axios.get(GET_ALL_LOCATIONS)
    return response.data
  } catch (error) {
    console.error('Error fetching getAllLocations data: ', error)
    throw error
  }
}

export const getAllApplParameters = async () => {
  try {
    const response = await axios.get(GET_ALL_APPL_PARAMETERS_1)
    return response.data
  } catch (error) {
    console.error('Error fetching getAllApplParameters data: ', error)
    throw error
  }
}
